(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          const header = document.getElementById('esbt-site-header') || document.querySelector('header-component');
          const headerHeight = header ? header.getBoundingClientRect().height : 0;
          const top = card.getBoundingClientRect().top + window.scrollY - headerHeight - 24;

          window.scrollTo({
            top: Math.max(0, top),
            behavior: 'auto',
          });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
